class FormatUtils {
  static formatDate(strDate) {
    if (strDate) {
      return FormatUtils.getFormattedDate(new Date(strDate));
    }

    return strDate;
  }

  static getFormattedDate(date) {
    var year = date.getFullYear();

    var month = (1 + date.getMonth()).toString();
    month = month.length > 1 ? month : "0" + month;

    var day = date.getDate().toString();
    day = day.length > 1 ? day : "0" + day;

    return month + "/" + day + "/" + year;
  }

  static formatMoney(strMoney) {
    if (/[a-z]/i.test(strMoney)) return strMoney;

    if (strMoney || strMoney === "0" || strMoney === 0) {
      return FormatUtils.getFormattedMoney(strMoney.toString());
    }

    return strMoney;
  }

  static getFormattedMoney(val) {
    if (~val.indexOf("$")) {
      val = val.replace("$", "").replace(/,/g, "");
    }

    let decimalPart = "00";
    if (~val.indexOf(".")) {
      decimalPart = val.substr(val.indexOf(".") + 1);
      val = val.substr(0, val.indexOf("."));
      if (Number(decimalPart) === 0 || decimalPart === "") {
        decimalPart = "00";
      }
    }

    return (
      "$" +
      val.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
      `.${decimalPart.padEnd(2, "0")}`
    );
  }

  static formatBool(strBool) {
    return strBool && strBool.length > 0 && strBool.toLowerCase() === "true"
      ? "Yes"
      : "No";
  }

  static formatLongText(str, allowedLenght) {
    if (str && str.length > allowedLenght) {
      return str.substr(0, allowedLenght) + "...";
    }
    return str;
  }

  static formatRef(ref) {
    if (!~ref.indexOf("http://") && !~ref.indexOf("https://")) return ref;

    return ref.substr(ref.indexOf("//") + 2);
  }

  static inputMoneyFormatter(val) {
    return val ? "$" + val : "$";
  }

  static getStatusStyle = (status, isExpired, { v2 } = { v2: false }) => {
    let statusBg = "#ffffff";
    let fontColor = "#ffffff";
    let isFontBlack = false;

    switch (status) {
      case "Ready to Bind":
      case "Ready to Issue":
        statusBg = "#388d41";
        break;
      case "Active":
        statusBg = "#104b00";
        break;
      case "Binder Received":
        statusBg = "#2f9f11";
        break;
      case "BOR Confirmed":
        statusBg = "#6f9b13";
        break;
      case "BOR Transfer":
        statusBg = "#8b9f60";
        isFontBlack = true;
        break;
      case "Issued":
        statusBg = "#197600";
        break;
      case "Request Issued":
        statusBg = "#6f9b13";
        break;
      case "RI Manual":
        statusBg = "#c6d62a";
        isFontBlack = true;
        break;
      case "Cancel/NR":
      case "Cancel":
      case "Cancelled":
        statusBg = "#b0aeca";
        break;
      case "Bind Declined":
      case "Carrier Declined":
      case "Internal Declined":
        statusBg = "#b22222";
        break;
      case "Bound":
        statusBg = "#9ed62a";
        isFontBlack = true;
        break;
      case "Selected":
        statusBg = "#b3e833";
        isFontBlack = true;
        break;
      case "Add. Info-Client":
      case "Additional Info":
        statusBg = "#d4d4d4";
        isFontBlack = true;
        break;
      case "Carrier Quoting":
        statusBg = "#d2b48c";
        isFontBlack = true;
        break;
      case "Proposed":
        statusBg = "#ffa500";
        isFontBlack = true;
        break;
      case "Needs UW Review":
        statusBg = "#ffab61";
        isFontBlack = true;
        break;
      default:
        statusBg = "#d4d4d4";
        isFontBlack = true;
        break;
    }

    if (v2) {
      switch (status) {
        case "Declined":
        case "Bind Declined":
        case "Carrier Declined":
        case "Internal Declined":
          statusBg = "#de463d";
          isFontBlack = false;
          break;
        default:
          break;
      }
    }

    if (isFontBlack) {
      fontColor = "#2b2a3a";
    }

    if (isExpired) {
      statusBg = "#b0aeca";
    }

    return { statusBg, fontColor };
  };
}

export default FormatUtils;
